import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/inventory/")({
  beforeLoad: () => {
    throw redirect({
      to: "/app/inventory/products",
      search: (prev) => prev,
    })
  },
})
